import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "./Time_Modal.css";
import Common_Btn from "../../common-btn/Common_Btn";

const Time_Modal = ({
  show,
  onHide,
  openingTime,
  setOpeningTime,
  openingPeriod,
  setOpeningPeriod,
  closingTime,
  setClosingTime,
  closingPeriod,
  setClosingPeriod,
  onDone,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      backdrop="static"
      className="time_modal_main"
    >
      <div className="time_modal">
        <div className="time_modal_header">
          <h5>Timing</h5>
          <span className="close_btn" onClick={onHide}>
            ×
          </span>
        </div>

        <div className="time_modal_body">
          <div className="time_row">
            <div className="row">
              <div className="col-lg-6">
                <div>
                  <label>Opening</label>
                  <div className="time_input_group">
                    <input
                      type="text"
                      value={openingTime}
                      onChange={(e) => setOpeningTime(e.target.value)}
                      placeholder="06:00"
                    />
                    <select
                      value={openingPeriod}
                      onChange={(e) => setOpeningPeriod(e.target.value)}
                    >
                      <option>AM</option>
                      <option>PM</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div>
                  <label>Closing</label>
                  <div className="time_input_group">
                    <input
                      type="text"
                      value={closingTime}
                      onChange={(e) => setClosingTime(e.target.value)}
                      placeholder="03:00"
                    />
                    <select
                      value={closingPeriod}
                      onChange={(e) => setClosingPeriod(e.target.value)}
                    >
                      <option>AM</option>
                      <option>PM</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="form_btn_holder" onClick={onDone}>
            <Common_Btn btnText={"Done"} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Time_Modal;
